export { default } from "./Tab.js";
export { default as tabClasses } from "./tabClasses.js";
export * from "./tabClasses.js";